/**
 * Splits an RFC-style address list on comma/semicolon while keeping separators
 * inside quoted display names (e.g. `"Doe, Jane" <jane@example.com>`).
 */
export const splitEmailAddressList = (addresses: string | null | undefined): string[] => {
  if (!addresses?.trim()) {
    return [];
  }

  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (let i = 0; i < addresses.length; i += 1) {
    const character = addresses[i];

    if (character === '"') {
      if (inQuotes && i > 0 && addresses[i - 1] === '\\') {
        current += character;
        continue;
      }

      inQuotes = !inQuotes;
      current += character;
      continue;
    }

    if (!inQuotes && (character === ',' || character === ';')) {
      const trimmed = current.trim();
      if (trimmed) {
        result.push(trimmed);
      }
      current = '';
      continue;
    }

    current += character;
  }

  const trimmed = current.trim();
  if (trimmed) {
    result.push(trimmed);
  }

  return result;
};
